import logo from "../../assets/logo-white.png";
import Nav from "../Nav";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container grid">
        {/* Logo */}
        <div id="footer-logo">
          <img
            src={logo}
            alt="Logo"
            style={{ minWidth: "6rem", width: "6rem" }}
          />
        </div>

        {/* Navigations */}
        <div id="footer-nav">
          <h4 style={{ marginTop: "0rem" }}>Doormat Navigation</h4>
          <Nav />
        </div>

        {/* Contact */}
        <div id="footer-contact">
          <h4 style={{ marginTop: "0rem" }}>Contact</h4>
          <ul>
            <li>Address</li>
            <li>Phone Number</li>
            <li>Email</li>
          </ul>
        </div>

        {/* Social Media */}
        <div id="footer-social">
          <h4 style={{ marginTop: "0rem" }}>Social Media Links</h4>
          <ul>
            <li>Address</li>
            <li>Phone Number</li>
            <li>Email</li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
